<mat-card>
    <mat-card-header>
        <mat-card-title class="d-flex" *ngIf="loginService.getActiveUserSubject()
        | async as activeUser"><span class="col-10"> User - {{activeUser.firstName}} {{activeUser.lastName}}</span>
            <span class="col-2">
            <button class="saveBTN" mat-raised-button [color]="'primary'" (click)="save()" id="saveBTN">
                Save
            </button>
            <button class="cancelBTN" mat-raised-button [color]="'secondary'" (click)="cancel()">
                Cancel
            </button>
        </span>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content class="row col-10 offset-xl-1 d-flex">
        <mat-card class="col-xl-5 col-lg-12">
            <mat-card-header>
                <mat-card-title>
                    Password
                </mat-card-title>
            </mat-card-header>

            <mat-card-content>
                <form [formGroup]="passwordForm">
                    <mat-form-field class="col-11">
                        <mat-label>Current Password</mat-label>
                        <input matInput type="password" formControlName="currentPassword" id="currentPassword">
                    </mat-form-field>
                    <mat-form-field class="col-11">
                        <mat-label>New Password</mat-label>
                        <input matInput type="password" formControlName="newPassword" id="newPassword">
                    </mat-form-field>
                    <mat-form-field class="col-11">
                        <mat-label>Confirm Password</mat-label>
                        <input matInput type="password" formControlName="confirmPassword" id="confirmPassword">
                    </mat-form-field>
                </form>
            </mat-card-content>
        </mat-card>
        <mat-card class="col-xl-5 col-lg-12">
            <mat-card-header>
                <mat-card-title>
                    Email
                </mat-card-title>
            </mat-card-header>

            <mat-card-content>
                <form [formGroup]="emailForm">
                    <mat-form-field class="col-11">
                        <mat-label>New Email</mat-label>
                        <input matInput type="email" formControlName="newEmail" id="newEmail">
                    </mat-form-field>

                    <mat-form-field class="col-11">
                        <mat-label>Confirm Email</mat-label>
                        <input matInput type="email" formControlName="confirmEmail" id="confirmEmail">
                    </mat-form-field>
                </form>
            </mat-card-content>
        </mat-card>
    </mat-card-content>
</mat-card>
